import { configureStore } from "@reduxjs/toolkit";
import commandesReducer from "./slice/CommandesSlice";
import reclamationReducer from "./slice/ReclamationSlice";
import reservationReducer from "./slice/ReservationSlice";
import printReducer from "./slice/PrintSlice";
import ProprieteReducer from "./slice/ProprieteSlice";
import GalerieContrat from "./slice/GalerieContrat";
import biensReducer from "./slice/BiensSlice";
import clientsReducer from "./slice/ClientsSlice";
import proprietaireReducer from "./slice/ProprietaireSlice";
import statistiqueReducer from "./slice/StatistiqueSlice";
import PermissionReducer from "./slice/Permission";
import proprietesVenteMaisonReducer from "./slice/proprietes/ProprietesVenteMaison";
import proprietesVenteTerrainReducer from "./slice/proprietes/ProprietesVenteTerrain";
import proprietesLocationsMaisonReducer from "./slice/proprietes/ProprieteLocationMaison";
import previsionsGlobaleReducer from "./slice/proprietes/PrevisionsGlobale";
import spinnerReducer from "./slice/Loading/SpinnerSlice";
import revenuGlobaleReducer from "./slice/proprietes/RevenusGlobale";
import recouvrementGlobaleReducer from "./slice/proprietes/RecouvrementGlobale";
import contratsReducer from "./slice/contrat/Contrat";

export const store = configureStore({
  reducer: {
    commnades: commandesReducer,
    reclamation: reclamationReducer,
    reservation: reservationReducer,
    print: printReducer,
    propriete: ProprieteReducer,
    galerie: GalerieContrat,
    biensReducer: biensReducer,
    clientsReducer: clientsReducer,
    proprietaireReducer: proprietaireReducer,
    statistiqueReducer: statistiqueReducer,
    permission: PermissionReducer,
    proprietesVenteMaisonStatistiqueFinance: proprietesVenteMaisonReducer,
    proprietesVenteTerrainStatistiqueFinance: proprietesVenteTerrainReducer,
    proprietesLocationMaisonStatistiqueFinance:
      proprietesLocationsMaisonReducer,
    previsionsGlobaleReducer: previsionsGlobaleReducer,
    revenuGlobaleReducer: revenuGlobaleReducer,
    recouvrementGlobaleReducer: recouvrementGlobaleReducer,
    contratsReducer: contratsReducer,
    spinnerReducer: spinnerReducer,
  },
});
